import { buildQuery } from '../../utils/buildQuery';
import api from '../../utils/api';

export const getAllStudentUser = async (params: ApplicantParams) => {
  const url = buildQuery(params);
  return (await api.get(`/Authorization/GetAllApplicant${url}`))?.data as UserResponse;
};

export const downloadStudentUsers = async (params: ApplicantParams) => {
  const url = buildQuery(params);
  return (await api.get(`/Authorization/downloadAllApplicant${url}`, { responseType: 'blob' }))?.data as Blob;
};

export const getApplicantPersonalInfo = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetPersonalInfoByApplicantId?Id=${applicantId}`))
    ?.data as APIResponse<PersonalInfo>;
};

export const getApplicantInstitution = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetInstitutionByApplicantId?Id=${applicantId}`))?.data as APIResponse<
    Institution[]
  >;
};

export const getApplicantWorkHistory = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetWorkHistoryByApplicantId?Id=${applicantId}`))?.data as APIResponse<
    WorkHistory[]
  >;
};

export const getApplicantQualifications = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetQualificationByApplicantId?Id=${applicantId}`))
    ?.data as APIResponse<Qualification[]>;
};

export const getApplicantJambResult = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetJambByApplicantId?Id=${applicantId}`))
    ?.data as APIResponse<JambResult | null>;
};

export const admitApplicants = async (payload: { applicationNumber: string[] }) => {
  return (await api.post(`/Authorization/AdmitApplicantsAsync`, payload))?.data as APIResponse<any>;
};

export const getPendingApprovals = async ({ stageOrder, page = 1, pageSize = 10 }: { stageOrder: number; page?: number; pageSize?: number }) => {
  return (await api.get(`/admission-approval/pending/${stageOrder}?page=${page}&pageSize=${pageSize}`))?.data;
};

export const bulkApproveAdmission = async (payload: { applicationNumbers: string[]; stageOrder: number; notes: string }) => {
  return (await api.post(`/admission-approval/bulk-approve`, payload))?.data as APIResponse<any>;
};

export const bulkRejectAdmission = async (payload: { applicationNumbers: string[]; stageOrder: number; notes: string }) => {
  return (await api.post(`/admission-approval/bulk-reject`, payload))?.data as APIResponse<any>;
};

export const batchRejectApplicants = async (payload: {
  applicationNumbers: string[];
  reason: string;
}) => {
  return (await api.post(`/Authorization/BatchRejectApplicants`, payload))?.data as APIResponse<any>;
};

export const batchResetRejection = async (payload: {
  applicantIds: string[];
  reason: string;
}) => {
  return (await api.put(`/StudentInfo/BatchResetRejection`, payload))?.data as APIResponse<any>;
};

export const getApplicantStudyDetails = async (applicantId: string) => {
  return (await api.get(`/Authorization/GetApplicantBiodataByApplicantId?applicantId=${applicantId}`))
    ?.data as APIResponse<StudyDetails>;
};

export const changeCourse = async (payload: {
  applicantId: string;
  newProgramId: number;
  newConcentrationId: number | null;
  reason: string;
}) => {
  return (await api.put('/StudentInfo/ChangeCourse', payload))?.data as APIResponse<any>;
};

export const getApplicantReferences = async (applicantId: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetAllReferences?ApplicantId=${applicantId}`))
    ?.data as APIResponse<ReferenceData[]>;
};

export const updateApplicantReferenceStatus = async ({ id, status }: { id: number; status: number }) => {
  return (await api.patch(`/StudentInfo/StudentInfo/UpdateReferenceStatus/${id}?status=${status}`)) // ✅ PATCH
    ?.data as Response;
};

export const getAdminUsers = async () => {
  return (await api.get(`/Authorization/GetAdminUsers?status=true`))?.data as AdminUser[];
};

export const createAdminUser = async (payload: CreateAdminUserPayload) => {
  return (await api.post(`/Authorization/registerAdmiUser`, payload))?.data as APIResponse<any>;
};

export const disableAdminUser = async ({ userId, disable }: { userId: string; disable: boolean }) => {
  return (await api.post(`/Authorization/DisableAdminUser?userId=${userId}&disable=${disable}`))?.data as APIResponse<any>;
};

export const addUserToRole = async (payload: { userName: string; roleName: string }) => {
  return (await api.post(`/Authorization/AddUserToRole/user`, payload))?.data as APIResponse<any>;
};

export const removeUserFromRole = async (payload: { userName: string; roleName: string }) => {
  return (await api.post(`/Authorization/RemoveUserFromRole`, payload))?.data as APIResponse<any>;
};

export const getRoles = async () => {
  return (await api.get(`/Authorization/getallroles`))?.data as Role[];
};

export const createRole = async (payload: { id: string; name: string; normalizedName: string; isActive: boolean }) => {
  return (await api.post(`/Authorization/createRole`, payload))?.data as APIResponse<any>;
};

export const getPermissions = async () => {
  return (await api.get(`/Authorization/GetAllPermission`))?.data as APIResponse<Permission[]>;
};

export const createUpdatePermission = async (payload: { id?: number; name: string; isActive: boolean; pathName: string }) => {
  return (await api.post(`/Authorization/CreateUpdatePermission`, payload))?.data as APIResponse<any>;
};

export const getPrivileges = async () => {
  return (await api.get(`/Authorization/GetAllPrivileges`))?.data as APIResponse<Privilege[]>;
};

export const createUpdatePrivilege = async (payload: { id: number; roleId: string; permissionId: number[] }) => {
  return (await api.post(`/Authorization/CreateUpdatePrivillege`, payload))?.data as APIResponse<any>;
};
